import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70a270c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "PlanOrderImportSettings-container container-fluid" }
const _hoisted_2 = { class: "row pt-2" }
const _hoisted_3 = { class: "col-6" }
const _hoisted_4 = { style: {"max-width":"360px"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Наименование", -1))
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Вкладка", -1))
const _hoisted_9 = { class: "col-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Заголовок колонки с примечанием", -1))
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, "Номер первой строки данных", -1))
const _hoisted_14 = { class: "col-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ModelField-label" }, " Номер строки заголовков полей и свойств ", -1))
const _hoisted_16 = {
  key: 0,
  class: "Changes-warning"
}
const _hoisted_17 = { class: "row pt-2" }
const _hoisted_18 = { class: "col-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dx-button-text" }, "Сохранить", -1))
const _hoisted_20 = { class: "row pt-2" }
const _hoisted_21 = { class: "col-6" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Настройка полей", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextControl = _resolveComponent("TextControl")!
  const _component_DxCheckBox = _resolveComponent("DxCheckBox")!
  const _component_IntegerControl = _resolveComponent("IntegerControl")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_CatalogueGrid = _resolveComponent("CatalogueGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.model.name), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_TextControl, {
            class: "ModelField-control",
            stylingMode: "outlined",
            placeholder: "Наименование...",
            "show-clear-button": true,
            value: _ctx.model.name,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.name) = $event)),
            hasEmptyValue: false,
            onChanged: _ctx.haveChanges
          }, null, 8, ["value", "onChanged"]),
          _createVNode(_component_DxCheckBox, {
            class: "Import-checkbox",
            value: _ctx.model.isClearBeforeImport,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.isClearBeforeImport) = $event)),
            text: "Очистка данных",
            onValueChanged: _ctx.haveChanges
          }, null, 8, ["value", "onValueChanged"]),
          _createVNode(_component_DxCheckBox, {
            class: "Import-checkbox",
            value: _ctx.model.isImportToLastNonEmptyRow,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.isImportToLastNonEmptyRow) = $event)),
            text: "Чтение до последней непустой строки",
            onValueChanged: _ctx.haveChanges
          }, null, 8, ["value", "onValueChanged"]),
          _createVNode(_component_DxCheckBox, {
            class: "Import-checkbox",
            value: _ctx.model.isExportCalculationResults,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.isExportCalculationResults) = $event)),
            text: "Выгружать результаты расчета",
            onValueChanged: _ctx.haveChanges
          }, null, 8, ["value", "onValueChanged"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_TextControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Вкладка...",
          "show-clear-button": true,
          value: _ctx.model.sheetName,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.sheetName) = $event)),
          hasEmptyValue: true,
          onChanged: _ctx.haveChanges
        }, null, 8, ["value", "onChanged"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_TextControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Заголовок колонки с примечанием...",
          "show-clear-button": true,
          value: _ctx.model.orderCommentColumnTitle,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.orderCommentColumnTitle) = $event)),
          hasEmptyValue: true,
          onChanged: _ctx.haveChanges
        }, null, 8, ["value", "onChanged"])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_IntegerControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Номер первой строки данных...",
          "show-clear-button": true,
          hasEmptyValue: true,
          value: _ctx.model.firstDataRowNumber,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.firstDataRowNumber) = $event)),
          onChanged: _ctx.haveChanges
        }, null, 8, ["value", "onChanged"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createVNode(_component_IntegerControl, {
          class: "ModelField-control",
          stylingMode: "outlined",
          placeholder: "Номер строки заголовков полей и свойств...",
          "show-clear-button": true,
          hasEmptyValue: true,
          value: _ctx.model.fieldPropertyRowNumber,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.fieldPropertyRowNumber) = $event)),
          onChanged: _ctx.haveChanges
        }, null, 8, ["value", "onChanged"])
      ])
    ]),
    (_ctx.changes)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Изменения вступят в силу после сохранения "))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_DxButton, {
          class: "Import-saveButton",
          type: "default",
          onClick: _ctx.onSave,
          "styling-mode": "outlined"
        }, {
          content: _withCtx(() => [
            _createElementVNode("span", null, [
              (_ctx.saving)
                ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                    key: 0,
                    icon: "circle-notch",
                    spin: ""
                  }))
                : _createCommentVNode("", true),
              _hoisted_19
            ])
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        (_ctx.model.id)
          ? (_openBlock(), _createBlock(_component_CatalogueGrid, {
              key: 0,
              controller: 'PlanOrderImportSettingsItem',
              columns: _ctx.columns,
              filterRowVisible: false,
              groupPanelVisible: false,
              headerFilterVisible: false,
              filterPanelVisible: false,
              showPageSizeSelector: true,
              pageSize: 20,
              pageSizes: _ctx.pageSizes,
              editingConfig: _ctx.editingConfig,
              selectionConfig: _ctx.selectionConfig,
              designConfig: _ctx.designConfig,
              parentModel: _ctx.model,
              popupCreateEditComponent: _ctx.planOrderSettingsItemCreateEditDialog
            }, null, 8, ["columns", "pageSizes", "editingConfig", "selectionConfig", "designConfig", "parentModel", "popupCreateEditComponent"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}